import React from 'react';
import { Route, Routes } from 'react-router-dom';
import NavigateWithMessage from '../components/NavigateWithMessage';
import CloseCashier from './pages/CloseCashier';
import CloseCashierHistory from './pages/CloseCashierHistory';
import { useCheckPermission } from '~/store/permission';

const Cashier = () => {
  const checkPermission = useCheckPermission();
  const isAllowedCashier = checkPermission('cashierBalancing:c');
  return (
    <Routes>
      <Route
        path="close"
        element={
          isAllowedCashier ? (
            <CloseCashier />
          ) : (
            <NavigateWithMessage
              to={'/'}
              message={{ type: 'error', text: 'Tidak diizinkan' }}
            />
          )
        }
      />
      <Route path="close/history" element={<CloseCashierHistory />} />
    </Routes>
  );
};

export default Cashier;
